'use client'

import { useInViewport } from '@/core/hooks/use-in-viewport'

type Props = {
  children: React.ReactNode
  onActive: () => void
  rootMargin?: string
  className?: string
}

export const InfiniteFetch: React.FC<Props> = ({
  children,
  onActive,
  rootMargin = '0px',
  className,
}) => {
  const [ref] = useInViewport({
    onEntryActive: onActive,
    observerOptions: {
      rootMargin,
    },
  })

  return (
    <div className={className}>
      {children}
      <span ref={ref} className='block h-1 w-full' aria-hidden='true'>
        &nbsp;
      </span>
    </div>
  )
}
